import { render } from "./_AccountsForm.vue?vue&type=template&id=1c8c03d4&scoped=true"
import script from "./_AccountsForm.vue?vue&type=script&lang=js"
export * from "./_AccountsForm.vue?vue&type=script&lang=js"

import "./_AccountsForm.vue?vue&type=style&index=0&id=1c8c03d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8c03d4"]])

export default __exports__